<style lang="scss" src="./style/index.scss" scoped></style>
<template>
    <div class="sw-error" v-if="currentStatus" :style="style">
        <div class="sw-error__status">
            <svg class="sw-symbol sw-error__symbol" aria-hidden="true">
                <use :xlink:href="'#' + currentStatus.icon"></use>
            </svg>
            <div class="sw-error__text">
            {{currentStatus[`text__${language}`]}}
            <br>
            <el-button v-if="buttonShow" type="text" @click="goBack">{{buttonText}}</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import json from './status.json'
import { mapState } from 'vuex'
// eslint-disable-next-line
import symbol from './lib/symbol.js';
export default {
  name: 'sw-error',
  props: {
    size: {
      type: String,
      default: 'normal'
    },
    code: {
      type: String,
      default: 'empty'
    },
    minHeight: {
      type: String,
      default: '300px'
    },
    buttonShow: {
      type: Boolean,
      default: false
    },
    buttonText: {
      type: String,
      default: '返回上一页'
    },
    backUrl: {
      type: String,
      default: ''
    },
    backFunction: {
      type: Function
    }
  },
  computed: {
    currentStatus () {
      return json[this.code]
    },
    style () {
      return {
        minHeight: this.minHeight
      }
    },
    ...mapState({
      language: state => state.language
    })
  },
  methods: {
    goBack () {
      if (this.backUrl) window.location.href = this.backUrl
      else if (typeof this.backFunction === 'function') this.backFunction()
      else this.$router.go(-1)
    }
  }
}

</script>
